// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__mOdok","label":"CategoryService_label__yKMoF","location":"CategoryService_location__3REXE"};